import { useAuthQuery } from '@rideiq/auth/hooks/useAuthQuery';
import { useFlags } from '@rideiq/contexts/LDContext';

export const useSisGate = (): boolean => {
  const { enableSisImports } = useFlags();
  const { userSettings } = useAuthQuery();

  return Boolean(enableSisImports && userSettings?.sisIntegration === 'Yes');
};
